var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(1745 -77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 37,
    height: 37,
    transform: "translate(-1745 77)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1735.598 123.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M21.951,7.958a1.577,1.577,0,0,0,0-2.283L19.016,2.739a1.577,1.577,0,0,0-2.283,0L4.5,14.972v5.219H9.719ZM17.874,3.881,20.81,6.817,18.363,9.263,15.427,6.327ZM6.131,18.56V15.624l8.155-8.155L17.222,10.4,9.067,18.56Z",
    transform: "translate(-4 -39)",
    fill: "#013871"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.26fb83505510afd233db9bff4e590ff8.svg";
export { ForwardRef as ReactComponent };